import React, { useEffect, useState, useContext } from "react";
import NavBar from "../../components/NavBar/NavBar";
import SideBar from "../../components/SideBar/SideBar";
import { ToastContainer, toast } from "react-toastify";
import Table from "../../components/Table/Table";
import {
  getAllTranscripts,
  saveTranscript,
} from "../../services/transcriptService";
import { getConfig } from "../../services/configService";
import AuthContext from "../../store/AuthContext";
import moment from "moment";
import useRecorder from "../../hooks/useRecorder";
import "./RecordScreen.css";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import { useBlocker, useLocation } from "react-router-dom";
import { updateTranscriptDraft } from "../../services/transcriptService";
import NavigatePrompt from "../../components/Modal/NavigatePrompt";
import AudioLevelBar from "./AudioLevelBar";

const RecordScreen = () => {
  const [timeoutTime, setTimeoutTime] = useState(6000); // Initial timeout time
  const [transcriptData, setTranscriptData] = useState(null);
  const [name, setName] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [functionData, setFunctionData] = useState(null);
  const authCtx = useContext(AuthContext);
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    startRecording,
    pauseRecording,
    resetRecording,
    resumeRecording,
    stopRecording,
    timeElapsed,
    recordingState,
    transcript,
    setTranscript,
    error,
    setError,
  } = useRecorder();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const initialPageNumber = queryParams.get("pageValue") || 1;
  const initialRowPerPage = queryParams.get("rowsPerPage") || 10;
  const initialSortBy = queryParams.get("sortBy") || "createdAt";
  const initialSortorder = queryParams.get("sortOrder") || "desc";

  const [rowsPerPage, setRowsPerPage] = useState(initialRowPerPage);
  const [pageNumber, setPageNumber] = useState(initialPageNumber || 1);
  const [totalRows, setTotalRows] = useState(0);

  const [sortBy, setSortBy] = useState(initialSortBy);
  const [sortOrder, setSortOrder] = useState(initialSortorder);

  const [showSaveedDraftNotification, setShowSaveedDraftNotification] =
    useState(false);

  let blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      transcript !== "" && currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    const getTranscripts = async () => {
      setLoading(true);
      const queryParams = new URLSearchParams({
        record: true,
        rowsPerPage: rowsPerPage,
        pageNumber: pageNumber,
        sortBy: sortBy,
        sortOrder: sortOrder,
        startDate: null,
        endDate: null,
      });

      try {
        const res = await getAllTranscripts(queryParams);
        if (res?.status === "success") {
          setLoading(false);
          setUploads(
            res?.result?.transcriptions ? res?.result?.transcriptions : []
          );
          setTotalRows(res?.result?.totalRows ? res?.result?.totalRows : 0);
        } else throw new Error("Fetching Failed");
      } catch (e) {
        setLoading(false);
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    getTranscripts();
    // eslint-disable-next-line
  }, [rowsPerPage, pageNumber, sortBy, sortOrder]);

  const PageChange = (val) => {
    setPageNumber(val);
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    searchParams.set("pageValue", val);
    url.search = searchParams.toString();
    window.history.pushState({ path: url.href }, "", url.href);
  };

  const manageSortBy = (a, b) => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    searchParams.set("sortBy", a);
    searchParams.set("sortOrder", b);
    url.search = searchParams.toString();
    window.history.pushState({ path: url.href }, "", url.href);

    setSortBy(a);
    setSortOrder(b);
  };

  const addTranscript = async () => {
    try {
      const draft = localStorage.getItem("draftId");
      const time = localStorage.getItem("time");

      console.log("draft", draft);
      console.log("Compare", localStorage.getItem("time"));

      if (draft !== null) {
        try {
          saveDraft();
        } catch (e) {
          console.log(e);
          localStorage.removeItem("draftId");
          localStorage.removeItem("time");
          resetRecording(1);
          setTranscriptData(null);
        }

        return;
      }

      if (name === "") {
        toast("No Name has been provided");
        setTranscriptData(null);
        return;
      }

      if (transcript === "") {
        toast("No Transcript has been generated");
        setTranscriptData(null);
        return;
      }

      const res = await saveTranscript(transcriptData);
      if (res?.status === "success") {
        resetRecording(2);
        setTranscriptData(null);
        toast("Transcript added successfully");
      } else throw new Error("Uploaded files data fetch failed");
    } catch (e) {
      console.log(e);
      resetRecording(3);
      setTranscriptData(null);
      toast(
        e?.response?.data?.message
          ? e?.response?.data?.message
          : "An error occured. Please try again"
      );
    }
  };

  useEffect(() => {
    if (transcriptData !== null) addTranscript();

    return () => {
      console.log("Working Check");
      localStorage.removeItem("draftId");
      localStorage.removeItem("time");
      stopRecording();
      setTranscriptData(null);
    };

    // eslint-disable-next-line
  }, [transcriptData]);

  // useEffect(() => {
  //   const getConfigData = async () => {
  //     try {
  //       const res = await getConfig();
  //       if (res?.status === "success") {
  //         setTimeoutTime(Number(res.config?.debounceTime) * 5000);
  //       } else throw new Error("Fetching Failed");
  //     } catch (e) {
  //       if (
  //         authCtx &&
  //         e?.response?.data?.message &&
  //         e?.response?.data?.message === "Config File does not exist"
  //       ) {
  //         return;
  //       }

  //       toast(
  //         e?.response?.data?.message
  //           ? e?.response?.data?.message
  //           : "An error occured. Please try again"
  //       );
  //     }
  //   };
  //   if (!authCtx.isSuperAdmin) {
  //     getConfigData();
  //   }
  //   // eslint-disable-next-line
  // }, []);

  const saveDraft = async (shouldReload = false) => {
    const draftId = localStorage.getItem("draftId");
    const time = localStorage.getItem("time");

    if (draftId === null && transcript !== "") {
      try {
        const time = Date.now() - localStorage.getItem("time");
        const res = await saveTranscript({
          duration: time,
          meetingId: `DRAFT : ${moment(new Date()).format(
            "Do MMMM YYYY hh:mm:ss a"
          )}`,
          rawTranscription: JSON.stringify([
            { text: transcript, highlight: false },
          ]),
          patientName: "Unknown",
          patientDOB: new Date(),
          meetingName: name?.length
            ? name
            : `DRAFT : ${moment(new Date()).format("Do MMMM YYYY hh:mm:ss a")}`,
          meetingPlatform: "SCRIBE-AI",
          summarizedTranscription: "",
          isTranscriptionComplete: true,
        });
        console.log("Saving New Transcript");
        if (res.status === "success") {
          localStorage.setItem("draftId", res.transcription.id);
          setName(name?.length ? name : res.transcription.meetingName);
        }

        if (shouldReload) {
          window.location.reload();
        }
      } catch (e) {
        console.log(e);
      }
    } else if (draftId !== null) {
      try {
        const time = Date.now() - localStorage.getItem("time");
        const res = await updateTranscriptDraft({
          rawTranscription: JSON.stringify([
            { text: transcript, highlight: false },
          ]),
          id: draftId,
          isTranscriptionComplete: true,
          duration: time,
          meetingName: name,
        });
        console.log("Saving Old Transcript");

        if (shouldReload) {
          window.location.reload();
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  useEffect(() => {
    // Set interval to periodically check and save draft
    const intervalId = setInterval(() => {
      saveDraft();
    }, timeoutTime);
    // Cleanup function to clear the interval on component unmount
    return () => clearInterval(intervalId);
  }, [transcript]);

  useEffect(() => {
    if (error !== "") {
      toast(error);
      setError("");
    }
  }, [error]);

  useEffect(() => {
    localStorage.removeItem("draftId");
    localStorage.removeItem("time");
  }, []);

  return (
    <>
      <ToastContainer />
      {isOpen && (
        <ConfirmModal
          isOpen={isOpen}
          setUploads={setUploads}
          setIsOpen={setIsOpen}
          functionData={functionData}
          setLoading={setLoading}
          setFunctionData={setFunctionData}
        />
      )}
      {blocker.state === "blocked" && (
        <NavigatePrompt
          blocker={blocker}
          resetRecording={() => resetRecording(5)}
          data={{
            duration: timeElapsed * 1000,
            meetingId: `${authCtx.user.name} - ${moment(new Date()).format(
              "Do MMMM YYYY hh:mm:ss a"
            )}`,
            rawTranscription: JSON.stringify([
              { text: transcript, highlight: false },
            ]),
            patientName: "Unknown",
            patientDOB: new Date(),
            meetingName: `${authCtx.user.name} - ${moment(new Date()).format(
              "Do MMMM YYYY hh:mm:ss a"
            )}`,
            meetingPlatform: "SCRIBE-AI",
            summarizedTranscription: "",
            isTranscriptionComplete: true,
          }}
          setTranscriptData={setTranscriptData}
        />
      )}
      <NavBar />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "200px 1fr",
          height: "-webkit-fill-available",
        }}
      >
        <SideBar />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            background: "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              background: "#fff",
              width: "100%",
              padding: "10px 40px",
            }}
          >
            <div class="audio-container">
              <div
                class="header-container"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-around",
                  alignItems: "center",
                  flex: 1,
                }}
              >
                <div>
                  <div class="header-sub-container">
                    <h2 class="upload-header-hd">
                      Your dictation will be transcribed automatically
                    </h2>
                    <p class="upload-header-para">
                      Tap the microphone to begin recording
                    </p>
                  </div>
                  <div class="audio-recording-container">
                    <div class="controls">
                      {recordingState === "idle" ? (
                        <button
                          onClick={() => {
                            startRecording();
                            localStorage.setItem("time", Date.now());
                          }}
                          class="btn start"
                        >
                          <ion-icon
                            name="mic"
                            style={{ color: "white", fontSize: 24 }}
                          ></ion-icon>
                        </button>
                      ) : recordingState === "paused" ? (
                        <button
                          onClick={resumeRecording}
                          class="btn resume ring"
                        >
                          <span></span>
                          <ion-icon
                            name="mic"
                            style={{ color: "white", fontSize: 24 }}
                          ></ion-icon>
                        </button>
                      ) : (
                        <button onClick={pauseRecording} class="btn pause">
                          <div class="audio-loader"></div>
                          <ion-icon
                            name="mic-off"
                            style={{ color: "white", fontSize: 24 }}
                          ></ion-icon>
                        </button>
                      )}
                    </div>

                    <AudioLevelBar recordingState={recordingState} />

                    <br></br>
                    <input
                      style={{
                        padding: "10px",
                        width: "100%",
                        marginBottom: 10,
                        border: "1px dashed rgb(110, 117, 255)",
                        borderRadius: "4px",
                      }}
                      placeholder={"Enter patient or note title "}
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    ></input>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    gap: "20px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "150px",
                      height: "40px",
                      background: "gray",
                      borderRadius: 5,
                      border: "1px solid gray",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      cursor: "pointer",
                      padding: "0 5px",
                      gap: "5px",
                      fontSize: "15px",
                    }}
                    onClick={() => {
                      pauseRecording();
                      setName("");
                      resetRecording(6);
                    }}
                  >
                    Reset
                  </div>

                  <div
                    style={{
                      display: "flex",
                      width: "150px",
                      height: "40px",
                      background: "rgba(110, 117, 255, 1)",
                      borderRadius: 5,
                      border: "1px solid rgba(110, 117, 255, 1)",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      cursor: "pointer",
                      padding: "0 5px",
                      gap: "5px",
                      fontSize: "15px",
                    }}
                    onClick={() => {
                      saveDraft(true);
                      // pauseRecording();
                      // resetRecording();
                      // setTranscriptData({
                      //   duration: Date.now() - localStorage.getItem("time"),
                      //   meetingId: `${authCtx.user.name} - ${moment(
                      //     new Date()
                      //   ).format("Do MMMM YYYY hh:mm:ss a")}`,
                      //   rawTranscription: JSON.stringify([
                      //     { text: transcript, highlight: false },
                      //   ]),
                      //   patientName: "Unknown",
                      //   patientDOB: new Date(),
                      //   meetingName: name,
                      //   meetingPlatform: "SCRIBE-AI",
                      //   summarizedTranscription: "",
                      //   isTranscriptionComplete: true,
                      // });

                      // console.log({
                      //   duration: Date.now() - localStorage.getItem("time"),
                      //   meetingId: `${authCtx.user.name} - ${moment(
                      //     new Date()
                      //   ).format("Do MMMM YYYY hh:mm:ss a")}`,
                      //   rawTranscription: JSON.stringify([
                      //     { text: transcript, highlight: false },
                      //   ]),
                      //   patientName: "Unknown",
                      //   patientDOB: new Date(),
                      //   meetingName: name,
                      //   meetingPlatform: "SCRIBE-AI",
                      //   summarizedTranscription: "",
                      //   isTranscriptionComplete: true,
                      // });
                    }}
                  >
                    {transcriptData === null ? (
                      <>
                        Save{" "}
                        <ion-icon
                          name="save-outline"
                          style={{ color: "white", fontSize: 24 }}
                        ></ion-icon>
                      </>
                    ) : (
                      <>Loading ...</>
                    )}
                  </div>
                </div>
              </div>
              <div
                class="sc-9cd5de1e-1 ysmhg"
                style={{ flex: 1, justifyContent: "space-between" }}
              >
                <div class="sc-ffe87d3e-0 gBCnOO">
                  <div
                    class="dropzone-main"
                    aria-disabled="false"
                    style={{
                      position: "relative",
                      height: "400px",
                    }}
                  >
                    <textarea
                      style={{
                        height: "100%",
                        width: "100%",
                        outline: "none",
                        border: "none",
                        resize: "none",
                        padding: "10px",
                        fontSize: 14,
                      }}
                      placeholder="Your transcription will appear here ..."
                      value={transcript}
                      onChange={(e) => {
                        setTranscript(e.target.value);
                      }}
                    ></textarea>
                  </div>
                </div>
                {showSaveedDraftNotification ? (
                  <div
                    style={{
                      padding: "10px",
                      color: "#fff",
                      backgroundColor: "grey",
                      margin: "10px auto",
                      borderRadius: "20px",
                      display: "flex",
                    }}
                  >
                    Transaciption Saved at {`${new Date()}`}
                  </div>
                ) : null}

                <br></br>
              </div>
              <br></br>
            </div>
            <Table
              totalRows={totalRows}
              pageNumber={pageNumber}
              setRowsPerPage={(data) => {
                setRowsPerPage(data);
                const url = new URL(window.location.href);
                const searchParams = new URLSearchParams(url.search);

                searchParams.set("rowsPerPage", data);
                url.search = searchParams.toString();
                window.history.pushState({ path: url.href }, "", url.href);
              }}
              rowsPerPage={rowsPerPage}
              setPageNumber={PageChange}
              data={uploads}
              pending={loading}
              dontShow={true}
              setIsOpen={setIsOpen}
              functionData={functionData}
              setFunctionData={setFunctionData}
              manageSortBy={manageSortBy}
              sortOrderPrev={sortOrder}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default RecordScreen;
